module.exports = __webpack_public_path__ + "img/logout.29c191cf.svg";